function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33227 0.217773C3.59314 0.217773 0.59314 3.86995 0.59314 7.91343C0.59314 9.86995 1.63662 11.8265 3.33227 12.8699C3.85401 13.1308 3.72357 12.8699 4.11488 11.3047C4.11488 11.1743 4.11488 11.0439 3.98444 10.9134C1.63662 8.04386 3.59314 2.43516 9.0714 2.43516C17.0279 2.43516 15.4627 13.3917 10.5062 13.3917C9.46271 13.5221 8.54966 12.7395 8.54966 11.696V11.1743C9.0714 9.73951 9.4627 8.43516 9.59314 7.00038C9.59314 4.26125 5.54966 4.65256 5.54966 8.30473C5.54966 8.9569 5.6801 9.60908 5.94097 10.1308C5.94097 10.1308 4.63662 15.4786 4.37575 16.3917C4.11488 17.9569 4.24531 19.5221 4.50618 20.9569C4.37575 21.0873 4.50618 21.0873 4.50618 21.0873H4.63662C5.54966 19.783 6.33227 18.4786 6.85401 17.0439C6.98444 16.3917 7.63662 14.0439 7.63662 14.0439C8.28879 14.9569 9.4627 15.4786 10.6366 15.4786C14.6801 15.4786 17.5497 11.9569 17.5497 7.65256C17.5497 3.34821 13.8975 0.217773 9.33227 0.217773Z",
  fill: "url(#paint0_linear_1972_20958)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1972_20958",
  x1: 17.3642,
  y1: 20.7892,
  x2: 17.3642,
  y2: 0.376063,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7F8FA"
})));

function SvgPinterestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/pinterest_icon.b81d75a8.svg";
export { ForwardRef as ReactComponent };